import { render, staticRenderFns } from "./FormularioPreFestival.vue?vue&type=template&id=492c77df&scoped=true&"
import script from "./FormularioPreFestival.vue?vue&type=script&lang=ts&"
export * from "./FormularioPreFestival.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioPreFestival.vue?vue&type=style&index=0&id=492c77df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492c77df",
  null
  
)

export default component.exports